/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Phone_LabelInputs */

const en_ticket_phone_label = /** @type {(inputs: Ticket_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone:`)
};

const ja_ticket_phone_label = /** @type {(inputs: Ticket_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話:`)
};

const fr_ticket_phone_label = /** @type {(inputs: Ticket_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone :`)
};

const de_ticket_phone_label = /** @type {(inputs: Ticket_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

/**
* | output |
* | --- |
* | "Phone:" |
*
* @param {Ticket_Phone_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_phone_label = /** @type {((inputs?: Ticket_Phone_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Phone_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_phone_label(inputs)
	if (locale === "ja") return ja_ticket_phone_label(inputs)
	if (locale === "fr") return fr_ticket_phone_label(inputs)
	return de_ticket_phone_label(inputs)
});